import { render, staticRenderFns } from "./TaskPromote.vue?vue&type=template&id=b9eac642&"
import script from "./TaskPromote.vue?vue&type=script&lang=js&"
export * from "./TaskPromote.vue?vue&type=script&lang=js&"
import style0 from "./TaskPromote.vue?vue&type=style&index=0&id=b9eac642&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports